export enum PersonType {
	LegalPerson = 0,
	Natural = 1,
}
